/**
 * Vuex Getters for the Model
 */
export const getters = {
  dag: state => state.model.dag,
  nodes: state => state.model.nodes,
  layout: state => state.model.layout,
  dagVersion: (_,getters) => `${getters.dag.version}${getters.nodes.version}`,

  /**
   * 
   */
  component: state => {
    if ('getComponent' in state.model) {
      return state.model.getComponent(state.label);
    } else {
      return {};
    }
  },


  /**
   * 
   */
  componentInputs: (state,getters) => {
    if (Array.isArray(state.label)) {
      return state.label.map(l => getters.dag.getInputs(l));
    } else {
      return getters.dag.getInputs(state.label);
    }
  },


  /**
   * 
   */
  data: (_,getters) => {
    if (Array.isArray(getters.component)) {
      return getters.component.map(c => c.data);
    } else {
      return getters.component.data;
    }
  },


  /**
   * 
   */
  method: (_,getters) => {
    if (Array.isArray(getters.component)) {
      return getters.component.map(c => c.method);
    } else {
      return getters.component.method;
    }    
  },


  /**
   * 
   */
  methodInputs: (_,getters) => {
    if (Array.isArray(getters.component)) {
      return getters.component.map(c => c.inputMapping);
    } else {
      return getters.component.inputMapping;
    }
  },


  /**
   * 
   */
  scenarios: (_,getters) => {
    if (Array.isArray(getters.component)) {
      return getters.component.map(c => c.scenarios);
    } else {
      return getters.component.scenarios;
    }
  }
};